













import { Route } from 'vue-router'
import { Component, Prop, Vue } from 'vue-property-decorator'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'

@Component
export default class RestaurantAmbience extends Vue {
  @Prop({ required: true, default: false }) public brighten!: boolean
  @Prop({ required: true, default: false }) public enableSound!: boolean

  public restaurantId: string = ''
  public restaurant: RestaurantPublic | null = null

  public async created() {
    this.restaurantId = (this.$route as Route).params.restaurantId

    // Get Restaurant details
    this.restaurant = await restaurants.getPublicRestaurant(this.restaurantId)
  }

  public mounted() {
    const audioEl = this.$refs.ambience as HTMLAudioElement
    if (audioEl) {
      this.$nextTick(() => {
        audioEl.volume = 0.06
      })
    }
  }
}
